/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Functional_Training_TermsInputs */

const en_service_type_functional_training_terms = /** @type {(inputs: Service_Type_Functional_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`functional fitness, kettlebell, trx, general fitness`)
};

const pl_service_type_functional_training_terms = /** @type {(inputs: Service_Type_Functional_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`funkcjonalny, trening ogólnorozwojowy, kettlebell, trx, sprawność`)
};

/**
* | output |
* | --- |
* | "functional fitness, kettlebell, trx, general fitness" |
*
* @param {Service_Type_Functional_Training_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_functional_training_terms = /** @type {((inputs?: Service_Type_Functional_Training_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Functional_Training_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_functional_training_terms(inputs)
	return en_service_type_functional_training_terms(inputs)
});